export async function runImportZipModulariseReview({
  files,
  targetFilePath,
  changeSummary,
  projectId,
}) {
  const res = await fetch('/api/dev-ide/modularise-review', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      files: Array.isArray(files) ? files : [],
      target_file_path: targetFilePath || null,
      change_summary: changeSummary || '',
      project_id: projectId || null,
    }),
  });

  const data = await res.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to verify modularisation.');
  }

  return data.review || null;
}
